import React, { useEffect, useState, useRef } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
// import "../PagesStyles/AdminMasters.css";
import style from "./VendorTouncheNew.module.css";
import Customertable from "Components/support/customervendor/customer";
import {
  a104,
  a107,
  a125,
  a128,
  a131,
  a134,
  a149,
  a163,
  a174,
  a179,
  a180,
  a191,
  a95,
  a98,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import GetApiService from "../../Api/getapiService.jsx";
import Stonetounch from "../../support/customertounchsupport/stones.jsx";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchVendorTouncheList } from "services/Tounches";
import PageLoader from "Components/PageLoader";

export default function VendorTounchNewList() {
  const navigate = useNavigate()
    
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);
  const [productsData, setProductsData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [designData, setDesignData] = useState([]);
  const [purityData, setPurityData] = useState([]);
  const [skuData, setSkuData] = useState([]);
  const [templateData, setTemplateData] = useState([]);

  const [filteredData, setFilteredData] = useState([]);
  const [fcat, setFcat] = useState("");
  const [fpro, setFpro] = useState("");

  const [allCategories, setAllCategories] = useState([]);
  const [allVendors, setAllVendors] = useState([]);
  const [newCategory, setNewCategory] = useState({
    VendorId: 0,
    CategoryId: 0,
    ProductId: 0,
    ClientCode: "",
    FinePure: false,
    PurityId: 0,
    FinePercentage: 0,
    WastageWt: "0",
    MakingFixedAmt: "0",
    MakingPerGram: "0",
    MakingFixedWastage: "0",
    MakingPercentage: "0",
    StockKeepingUnit: "",
    CompanyId: 0,
    CounterId: 0,
    BranchId: 0,
    EmployeeId: 0,
    OldEntry: false,
    DiamondSizeWeightRateTemplateId: 0,
    Stones: [],
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allSelectedTounche, setAllSelectedTounche] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [showSKU, setShowSKU] = useState(true);
  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };
  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };

  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const CompanyId = adminLoggedIn.CompanyId;
  const BranchId = adminLoggedIn.BranchId;
  const CounterId = adminLoggedIn.CounterId;
  const EmployeeId = adminLoggedIn.EmployeeId;
  const [allStonesList, setAllStonesList] = useState([]);
  const submitButtonRef = useRef(null); // Ref for the Submit button
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);
  const inputRef9 = useRef(null);
  const inputRef10 = useRef(null);
  const inputRef11 = useRef(null);

  const handleReset = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  // Focus inputRef1 on component mount
  useEffect(() => {
    inputRef1.current?.focus();
  }, []);

  // Handler function to move focus on Enter key press
  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error("Submit button ref is not available");
        }
      }
    }
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const apiService = new GetApiService(clientCode);

  const loadData = async () => {
    setLoading(true);
    try {
      const apiCalls = [apiService.fetchAllStonesList()];

      const results = await Promise.allSettled(apiCalls);

      results.forEach((result, index) => {
        if (result.status === "fulfilled") {
          // Handle successful response
          switch (index) {
            case 0:
              const fetchedStones = result.value;

              // Convert the fetched stones to the required structure
              const formattedStones = fetchedStones.map((stone) => ({
                CustomerId: 0, // Keep CustomerId as 0
                VendorId: 0, // Keep VendorId as 0 for now, will change later
                StoneId: stone.Id,
                StoneName: stone.StoneName,
                StoneWeight: stone.StoneWeight,
                StonePieces: stone.StonePieces,
                StoneRate: stone.StoneRate,
                StoneAmount: stone.StoneAmount,
                StoneLessPercent: stone.StoneLessPercent,
              }));

              console.log("Converted stones:", formattedStones);

              // Set the new category with the converted stones
              setNewCategory((prevCategory) => ({
                ...prevCategory,
                Stones: formattedStones, // Set the converted stones here
              }));

              setAllStonesList(formattedStones);

              break;

            default:
              break;
          }
        } else {
          if (index + 1 > 1) {
            console.error(
              `Error loading data for API ${index + 1}:`,
              result.reason
            );
            // handleError(
            //   `Failed to load data for API ${index + 1}: ${result.reason}`
            // );
          }
        }
      });
    } catch (error) {
      console.error("Error loading data:", error);
      //   handleError("Error loading data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [clientCode]);

  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a174, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        console.log("check mainitems ", data);
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log("category")
    fetchAllCategory();
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a125, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => setCategoriesData(data));
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a128, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((x) => x.json())
      .then((y) => {
        setProductsData(y);
      });
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a134, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("checking products ", data);
        setPurityData(data);
      });
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a131, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => setDesignData(data));
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a163, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("checking sku data 1", data);
        setSkuData(data);
      });
  }, []);

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a191, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjIwMzc1MDA4NTksImlzcyI6Ijk4Nzk4ODc2NzU3NjU2NjU0NjU0IiwiYXVkIjoiSW5mb0Bsb3lhbHN0cmluZy5jb20ifQ.nOtc537wlSYm_97ljruCyOcG7wjXOrNUtxZy206OfOQ",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        const processedData = data?.map((item) => ({
          templateID: item?.Id,
          templateName: item?.TemplateName || "default",
        }));
        setTemplateData(processedData);
      });
  }, []);

  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllRoles();
  }, []);

  const fetchAllVendors = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a149, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllVendors(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllVendors();
  }, []);

  const handleNewCategoryChange = (e) => {
    const { name, value, key } = e.target;
    let actualValue = value;
    if (name === "FinePure") {
      actualValue = value === "true";
    }

    if (name == "StockKeepingUnit") {
      let selectedSku = skuData.find((x) => x.StockKeepingUnit == value);
      if (selectedSku) {
        handleAllSelectedTounche(e, selectedSku);
      } else {
        setNewCategory({ ...newCategory, [name]: actualValue });
      }
    }
    setNewCategory({ ...newCategory, [name]: actualValue });
  };



  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      
  ];


 
   

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);

  const handleEditData = (data) => {
    console.log(data, "editData");

    // Create a Set to keep track of existing StoneIds in data.Stones
    const existingStoneIds = new Set(data.Stones.map((stone) => stone.StoneId));

    // Create a Set to keep track of StoneIds already added from allStonesList
    const addedStoneIds = new Set();

    // Loop through allStonesList and check for duplicates
    allStonesList.forEach((item) => {
      // Check if the item already exists in data.Stones based on StoneId
      if (
        !existingStoneIds.has(item.StoneId) &&
        !addedStoneIds.has(item.StoneId)
      ) {
        const newStone = {
          CustomerId: 0, // Keep CustomerId as 0
          VendorId: 0, // Keep VendorId as 0 for now
          StoneId: item.StoneId,
          StoneName: item.StoneName,
          StoneWeight: item.StoneWeight,
          StonePieces: item.StonePieces,
          StoneRate: item.StoneRate,
          StoneAmount: item.StoneAmount,
          StoneLessPercent: item.StoneLessPercent,
        };

        // Add the new stone to data.Stones
        data.Stones.push(newStone);

        // Add StoneId to addedStoneIds to prevent future duplicates in this iteration
        addedStoneIds.add(item.StoneId);
      }
    });

    console.log("Updated Stones:", data.Stones); // Log the updated stones

    // Update data with the new Stones array and set the new category
    setNewCategory({
      ...data,
      Stones: data.Stones, // Use the updated stones
      OldEntry: true,
      // Add other properties here as needed
    });

    // console.log('checking stones  ',updatedStones )
    // // Update data with the new Stones array and set the new category
    // setNewCategory({
    //     ...data,
    //     Stones: updatedStones,
    //     OldEntry: true
    // });

    // setNewCategory({...data, OldEntry: true});
    setActive("AddNew");
  };

  const handleAllSelectedTounche = (e, x) => {
    const { value, checked } = e.target;
    if (checked) {
      const newTounche = {
        VendorId: parseInt(newCategory.VendorId),
        CategoryId: parseInt(x.CategoryId),
        ProductId: parseInt(x.ProductId),
        PurityId: parseInt(x.PurityId),
        FinePercentage: newCategory.FinePercentage,
        ClientCode: clientCode,
        FinePure: newCategory.FinePure,
        WastageWt: newCategory.WastageWt,
        MakingFixedAmt: newCategory.MakingFixedAmt,
        MakingPerGram: newCategory.MakingPerGram,
        MakingFixedWastage: newCategory.MakingFixedWastage,
        MakingPercentage: newCategory.MakingPercentage,
        StockKeepingUnit: x.StockKeepingUnit,
        CompanyId: CompanyId ? CompanyId : 0,
        CounterId: CounterId ? CounterId : 0,
        BranchId: BranchId ? BranchId : 0,
        EmployeeId: EmployeeId ? EmployeeId : 0,
        DiamondSizeWeightRateTemplateId: parseInt(
          x.DiamondSizeWeightRateTemplateId
        ),
      };
      setAllSelectedTounche([...allSelectedTounche, newTounche]);
    } else {
      setAllSelectedTounche(
        allSelectedTounche.filter((item) => item.StockKeepingUnit !== value)
      );
    }
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setAllSelected(checked);
    if (checked) {
      const selectedItems = skuData
        .filter((sku) => {
          const parsedVendorId = parseInt(newCategory.VendorId);
          const matchesVendor =
            newCategory.VendorId !== null &&
            newCategory.VendorId !== "" &&
            sku.SKUVendor.some((x) => x.VendorId === parsedVendorId);

          const matchesCategory =
            newCategory.CategoryId === 0 ||
            newCategory.CategoryId === "" ||
            newCategory.CategoryId === null
              ? true
              : sku.CategoryId === parseInt(newCategory.CategoryId);

          const matchesProduct =
            newCategory.ProductId === 0 ||
            newCategory.ProductId === "" ||
            newCategory.ProductId === null
              ? true
              : sku.ProductId === parseInt(newCategory.ProductId);

          const matchesPurity =
            newCategory?.PurityId === 0 ||
            newCategory?.PurityId === "" ||
            newCategory?.PurityId === null
              ? true
              : sku?.PurityId === parseInt(newCategory?.PurityId);

          return (
            matchesVendor && matchesCategory && matchesProduct && matchesPurity
          );
        })
        .map((x) => createTouncheObject(x));
      setAllSelectedTounche(selectedItems);
    } else {
      setAllSelectedTounche([]);
    }
  };

  const handleIndividualCheckboxChange = (e, item) => {
    const checked = e.target.checked;
    if (checked) {
      setAllSelectedTounche((prev) => [...prev, createTouncheObject(item)]);
    } else {
      setAllSelectedTounche((prev) =>
        prev.filter((x) => x.StockKeepingUnit !== item.StockKeepingUnit)
      );
      setAllSelected(false);
    }
  };

  const createTouncheObject = (x) => ({
    VendorId: parseInt(newCategory.VendorId),
    CategoryId: parseInt(x.CategoryId),
    ProductId: parseInt(x.ProductId),
    PurityId: parseInt(x.PurityId),
    FinePercentage: newCategory.FinePercentage,
    ClientCode: clientCode,
    FinePure: newCategory.FinePure,
    WastageWt: newCategory.WastageWt,
    MakingFixedAmt: newCategory.MakingFixedAmt,
    MakingPerGram: newCategory.MakingPerGram,
    MakingFixedWastage: newCategory.MakingFixedWastage,
    MakingPercentage: newCategory.MakingPercentage,
    StockKeepingUnit: x.StockKeepingUnit,
    CompanyId: CompanyId ? CompanyId : 0,
    CounterId: CounterId ? CounterId : 0,
    BranchId: BranchId ? BranchId : 0,
    EmployeeId: EmployeeId ? EmployeeId : 0,
    DiamondSizeWeightRateTemplateId: parseInt(
      x.DiamondSizeWeightRateTemplateId
    ),
  });
  //   console.log("active", active);

  const getNameFunction = (e) => {
    const matchedObject = templateData?.find((item) => item?.templateID === e);
    return matchedObject ? matchedObject.templateName : null;
  };

  const handleAmountChange = (index, newRate) => {
    // Update the stone rate at the specified index
    setNewCategory((prevCategory) => {
      const updatedStones = [...prevCategory.Stones];
      updatedStones[index].StoneRate = newRate;
      return {
        ...prevCategory,
        Stones: updatedStones,
      };
    });
  };

  const handleList = () => {
    // Custom logic for the List button
    console.log("List button clicked");
    setActive("List");
  };

  const columns = [
    { key: "serialNumber", label: "Sr.No", type: "read", priority: 1 },
    { key: "VendorName", label: "Vendor", type: "read", priority: 2 },
    { key: "Category", label: "Category", type: "read", priority: 3 },
    { key: "Product", label: "Product", type: "read", priority: 4 },
    { key: "Design", label: "Design", type: "read", priority: 5 },
    { key: "Purity", label: "Purity", type: "read", priority: 6 },
    { key: "sku", label: "SKU", type: "read", priority: 7 },
    { key: "Wastage", label: "Wastage", type: "read", priority: 8 },
    {
      key: "MakingFixedAmt",
      label: "Making FixedAmt",
      type: "read",
      priority: 9,
    },
    {
      key: "Making Percentage",
      label: "MakingPercentage	",
      type: "read",
      priority: 10,
    },
    {
      key: "MakingPerGram",
      label: "Making PerGram",
      type: "read",
      priority: 11,
    },
    {
      key: "TemplateName",
      label: "Template Name",
      type: "read",
      priority: 12,
    },
  ];

  const handlenew = () => {
    setActive("AddNew");
  };

  const {
    data: vendorTounchelist,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["vendorTounche/vendorTouncheList",clientCode],
    queryFn: fetchVendorTouncheList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  
  useEffect(()=>{

  },[])

  console.log(vendorTounchelist)

  
  return (
    <div>
      {isLoading && <PageLoader/>}
      <AdminHeading />
      <div style={{ paddingTop: "130px" }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Vendor Tounche"}
          companyName={"Loyalstring"}
          module={"Settings"}
          page={"Vendor Tounche"}
        />
      </div>
      <div style={{ padding: "16px" }}>
      <>
             <div className={style["white-space"]}>
               

               <div className={style["icon-div"]}>
                 <div className={style["search-container"]}>
                   <input
                     type="text"
                     value={searchInput}
                     onChange={handleSearchChange}
                     placeholder="Search..."
                     className={style["serach-input"]}
                   />
                   <button
                     style={{ margin: 0 }}
                     className={style["search-btn"]}
                     onClick={handleSearchSubmit}
                   >
                     <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                   </button>
                 </div>
                 
                 <Icon
                 
                   style={{
                     fontSize: "28px ",
                     color: "#0077d4",
                     cursor: "pointer",
                   }}
                   icon="bx:export"
                 />
                 
                
                 <button
                   // style={{ width: "30%" }}
                   className={style["custom-btn"]}
                 >
                   <Icon
                     style={{ fontSize: "24px " }}
                     icon="ic:outline-print"
                   />
                   Print
                 </button>
                 <button 
                //  onClick={handlenew} 
                 onClick={()=>navigate("/vendor_tounche_new")} 
                 style={{ margin: 0 }} className={style["custom-btn"]}>
                 New
                 <Icon icon="mdi:plus" width="24" height="24" />
               </button>
               </div>
             </div>

            <Customertable
              columns={columns}
              allCategories={vendorTounchelist}
              handleEditData={handleEditData}
              searchInput={searchInput}
              setSearchInput={setSearchInput}

              // title={"All Customers"}
            />
          </>
       
        
      </div>
    </div>
  );
}
